import React from 'react';
import DeleteIcon from '@/icons/DeleteIcon';
import './floating-dock.less';

export const FloatingDockClose = ({ closeDock }) => (
    <div className="floating-dock-close" onClick={closeDock}>
        <DeleteIcon />
    </div>
);

function FloatingDock({ children }) {
    return children(false, () => {});
}

export default FloatingDock;
